import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-ascending",
  "use": "sort-ascending-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sort-ascending\"><path fill-rule=\"evenodd\" d=\"M9 6v2H3V6h6ZM3 16h18v2H3v-2Zm12-5v2H3v-2h12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol